import './Pocetna.css';
import computerImage from '../assets/computer-1591018_1920.jpg';
import cyberImage from '../assets/cyber-security.jpg';
import speedmImage from '../assets/speedm.jpg';

function Pocetna() {
  return (
    <div className="pocetna-container">
      
      {/* Hero Section */}
      <div className="hero-section">
        <h1 className="pocetna-title">Dobrodošli u KEHSEF d.o.o.</h1>
        <p className="pocetna-subtitle">Vaš partner za IT rješenja i kibernetičku sigurnost</p>
      </div>

      {/* Quick Guide Section - Highlighted */}
      <div className="quick-guide-section">
        <div className="pocetna-content-box guide-box">
          <h2 className="pocetna-title">Brzi vodič za kibernetičke incidente</h2>
          <p className="pocetna-description">
            U slučaju kibernetičkog incidenta, slijedite ove ključne korake:
          </p>
          
          <div className="pocetna-addins">
            <div className="pocetna-addin first">
              <h3 className="pocetna-addin-title">1. Identifikacija i analiza</h3>
              <p className="pocetna-addin-text">
                Analizirajte logs, nadzor mrežnog prometa i evaluirajte prijave korisnika. 
                Utvrdite koji su informacijski resursi kompromitirani.
              </p>
            </div>

            <div className="pocetna-addin second">
              <h3 className="pocetna-addin-title">2. Suzbijanje i izolacija</h3>
              <p className="pocetna-addin-text">
                Odmah odspojiite zahvaćene jedinice s mrežne infrastrukture. 
                Suspendirajte kompromitirane korisničke račune.
              </p>
            </div>

            <div className="pocetna-addin first">
              <h3 className="pocetna-addin-title">3. Uklanjanje i oporavak</h3>
              <p className="pocetna-addin-text">
                Uklonite maliciozni kod, ažurirajte sustav i promijenite sve lozinke. 
                Restaurirajte podatke iz sigurnih kopija.
              </p>
            </div>

            <div className="pocetna-addin second">
              <h3 className="pocetna-addin-title">4. Izvještavanje</h3>
              <p className="pocetna-addin-text">
                Izvijestite AZOP u roku od 72 sata u slučaju povrede osobnih podataka. 
                Prijavite incident nadležnim tijelima (Nacionalni CERT, MUP).
              </p>
            </div>

            <div className="pocetna-addin first">
              <h3 className="pocetna-addin-title">5. Zakonska usklađenost i izvještavanje</h3>
              <p className="pocetna-addin-text">
                Sukladno GDPR uredbi, obveza je izvijestiti Agenciju za zaštitu osobnih podataka (AZOP) u roku od 24 sata. 
                Institucionalna suradnja s Nacionalnim CERT-om ili MUP-om radi daljnje obrade incidenta.
              </p>
            </div>

            <div className="pocetna-addin second">
              <h3 className="pocetna-addin-title">6. Post-incidentna analiza</h3>
              <p className="pocetna-addin-text">
                Evaluacija učinkovitosti provedenih mjera i prepoznavanje kritičnih točaka. 
                Revizija Plana odgovora na incidente (IRP) na temelju stečenih iskustava za prevenciju budućih incidenata.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Two Column Layout for Speed Momentum and Cyber Security */}
      <div className="two-column-section">
        
        {/* Speed Momentum Section */}
        <div className="pocetna-content-box column-box">
          <div className="cyber-image-container">
            <img 
              src={speedmImage} 
              alt="Speed Momentum Tools"
              className="cyber-image"
            />
          </div>
          <h2 className="section-title">Speed Momentum Tools</h2>
          <p className="pocetna-description">
            Naša tvrtka je distributer alata <strong>Speed Momentum</strong>. 
            Speed Momentum Tools i Speed Momentum Sampling dodaci su za Excel (add-ins) 
            dizajnirani za automatizaciju i ubrzavanje ručnih procesa za korisnike Excela.
          </p>
          <a 
            href="https://www.speed-momentum.com/en" 
            target="_blank" 
            rel="noopener noreferrer"
            className="pocetna-link"
          >
            Saznajte više o Speed Momentum
          </a>
        </div>

        {/* Cyber Security Services */}
        <div className="pocetna-content-box column-box">
          <div className="cyber-image-container">
            <img 
              src={cyberImage} 
              alt="Kibernetička sigurnost"
              className="cyber-image"
            />
          </div>
          <h2 className="section-title">Usluge kibernetičke sigurnosti</h2>
          <p className="pocetna-description">
            Nudimo profesionalne usluge zaštite vaših digitalnih resursa i podataka. 
            Naš tim stručnjaka osigurava zaštitu od kibernetičkih prijetnji i incidenata, 
            uz praćenje i reagiranje na sigurnosne izazove.
          </p>
          <a href="/usluge" className="pocetna-link">
            Pogledajte naše usluge
          </a>
        </div>
      </div>

      {/* Call to Action */}
      <div className="cta-section">
        <div className="pocetna-content-box cta-box">
          <h2 className="section-title">Trebate pomoć?</h2>
          <p className="pocetna-description">
            Kontaktirajte nas za savjetovanje ili podršku u vezi IT rješenja i kibernetičke sigurnosti.
          </p>
          <a href="/kontakt" className="pocetna-link cta-button">
            Kontaktirajte nas
          </a>
        </div>
      </div>

    </div>
  );
}

export default Pocetna;
